import timeZoneCityToCountryJson from "../data/timeZoneToCountry.json";

function userTimeZoneCountryCode() {
  type JsonKeys = keyof typeof timeZoneCityToCountryJson;
  // let userRegion;
  let userCity: JsonKeys = "London";
  let userCountry = "GB";
  let userTimeZone;

  if (Intl) {
    userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const tzArr = userTimeZone.split("/");
    // userRegion = tzArr[0];
    userCity = tzArr[tzArr.length - 1] as JsonKeys;
    userCountry = timeZoneCityToCountryJson[userCity];
  }
  // if (import.meta.env.VITE_PUBLIC_DEV) {
  // console.log("Time Zone:", userTimeZone);
  // console.log("Country:", userCountry, "City:", userCity, "Region:", userRegion);
  // }

  return userCountry;
}

export default userTimeZoneCountryCode;
